$(document).ready( function() {
  $(function() {
    var holiday = function(date) {
        var disabledDays = ["24-12-2020","25-12-2020","26-12-2020","27-12-2020","28-12-2020","29-12-2020","30-12-2020","31-12-2020","1-1-2021","2-1-2021","3-1-2021","4-1-2021","5-1-2021","6-1-2021","7-1-2021","8-1-2021"];
        var m = date.getMonth(), d = date.getDate(), y = date.getFullYear();
        for (i = 0; i < disabledDays.length; i++) {
          if($.inArray(d + '-' + (m+1) + '-' + y,disabledDays) != -1 ) {
            return true;
          }
        }
        return false;
      }
    var min=7;

    /*switch (new Date().getDay()) {
      case 4:
           min = 5;
           break;  
      case 5:
           min = 5;
           break;
        case 6:
           min = 4;
           break;
    } */
    $("#date1").datepicker( {
      minDate: 7,
      maxDate: '+2M',
      beforeShowDay: function(day) {
        var weekday = day.getDay();
        if (weekday == 0 || weekday == 6 || holiday(day)) {
          return [false]
        } else {
          return [true]
        }
      },
      dateFormat: "dd/mm/yy",
      onSelect: function(dateText){
        var seldate = $(this).datepicker('getDate');
        seldate = seldate.toDateString();
        seldate = seldate.split(' ');
        var weekday=new Array();
            weekday['Mon']="Monday";
            weekday['Tue']="Tuesday";
            weekday['Wed']="Wednesday";
            weekday['Thu']="Thursday";
            weekday['Fri']="Friday";
            weekday['Sat']="Saturday";
            weekday['Sun']="Sunday";
        var dayOfWeek = weekday[seldate[0]];
        $('#dayOfWeek').val(dayOfWeek);
        $('#dayOfWeekMessage').html(dayOfWeek);
   }
  });
 });
});